import React, { useEffect, useRef } from 'react';
import p5 from 'p5';

interface BaseSimulationProps {
  sketch: (p: p5) => void;
  title: string;
  description: string;
  aboutContent?: React.ReactNode;
}

const BaseSimulation: React.FC<BaseSimulationProps> = ({ sketch, title, description, aboutContent }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const p5InstanceRef = useRef<p5 | null>(null);

  useEffect(() => {
    if (containerRef.current && !p5InstanceRef.current) {
      p5InstanceRef.current = new p5(sketch, containerRef.current);
    }

    return () => {
      if (p5InstanceRef.current) {
        p5InstanceRef.current.remove();
        p5InstanceRef.current = null;
      }
    };
  }, [sketch]);

  return (
    <div className="space-y-4">
      <div className="section-card">
        <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        <div 
          ref={containerRef} 
          className="border-2 border-gray-200 rounded-lg overflow-hidden bg-white"
        />
      </div>
      <div className="info-section">
        <h4 className="text-sm font-semibold text-blue-900 mb-2">About This Simulation</h4>
        {aboutContent ? (
          aboutContent
        ) : (
          <p className="text-sm text-gray-700">
            This interactive visualization demonstrates the mathematical model in real-time. 
            The simulation updates continuously to show how the optimization algorithm works.
          </p>
        )}
      </div>
    </div>
  );
};

export default BaseSimulation;
